import React, { useState, useCallback } from 'react';
import { Tooltip, App } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const CopyableText = ({ text, maxLength }) => {
  const [copied, setCopied] = useState(false);
  const { message } = App.useApp();

  const handleCopy = useCallback((e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      message.success('已复制到剪贴板');
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {
      message.error('复制失败');
    });
  }, [text, message]);

  if (!text) return '-';

  const displayText = maxLength && text.length > maxLength
    ? `${text.slice(0, maxLength)}...`
    : text;

  return (
    <span
      style={{
        fontFamily: 'monospace',
        fontSize: '12px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px'
      }}
    >
      <Tooltip title={text}>
        <span>{displayText}</span>
      </Tooltip>
      <CopyOutlined
        style={{
          fontSize: 10,
          cursor: 'pointer',
          color: copied ? '#52c41a' : '#999',
          transition: 'color 0.2s'
        }}
        onClick={handleCopy}
      />
    </span>
  );
};

export default CopyableText;
